// extracted by mini-css-extract-plugin
export default {"slc":"Temperaments_slc__Z0-pj"};